export const WRESTLER_NONE_ID = 971;
export const TEAM_NONE_ID = 102;
